import axios from 'axios'
import {ApiResponse} from '../models/Base'
import { UserHealthDto, UserHealthFilterDto, UserHealthRequestDto } from '../models/dto/UserProfile'
const API_URL = process.env.REACT_APP_API_URL
const USER_PROFILE_URL = `${API_URL}/user-health`

export function GetById(payload: number) {
    return axios.get<ApiResponse<UserHealthDto>>(`${USER_PROFILE_URL}/${payload}`)
}

export function GetLast(payload: UserHealthFilterDto) {
    return axios.post<ApiResponse<UserHealthDto[]>>(`${USER_PROFILE_URL}/lasts`,payload)
}

export function Create(payload: UserHealthRequestDto) {
    return axios.post(`${USER_PROFILE_URL}`, payload)
}

export function Update(id: number, payload: UserHealthRequestDto) {
    return axios.put(`${USER_PROFILE_URL}/${id}`, payload)
}

